<template>
  <div
    id="org-manage"
    class="org-manage"
  >
    <div
      id="header"
      class="org-manage-header"
    >
      組別管理
    </div>
    <el-container>
      <el-aside
        :width="isExpanded ? '700px' : '270px'"
        :style="{ height: asideHeight + 'px' ,position :isExpanded?'absolute':'',zIndex:isExpanded?2:0}"
      >
        <aside-bar
          :is-expanded.sync="isExpanded"
          :tree-data-list="treeData"
          :loading="treeLoading"
          :aside-height="asideHeight"
          @choose="choseOrganization"
        />
      </el-aside>
      <el-main id="org-main">
        <div
          v-if="permissions.System_Org_Manager"
          class="operate-btn"
        >
          <el-tooltip
            content="新增組別"
            placement="top"
          >
            <span
              class="create-org"
              @click="
                $router.push({
                  path: `/org-manage/create`,
                  query: {
                    parentName: selectedDepartment.departmentName,
                    parentId: selectedDepartment.departmentID
                  }
                })
              "
            >
              <icon-svg
                name="xinzengzuzhi1-copy"
                class="add-org-icon"
              />
              <span class="svg-tit">新增組別</span>
            </span>
          </el-tooltip>
          <div class="vertical-line" />
          <el-tooltip
            content="修改組別"
            placement="top"
          >
            <span
              title="修改組別"
              @click="handleEdit(selectedDepartment)"
            >
              <icon-svg
                name="xiugai-copy"
                class="edit-org-icon"
              />
              <span class="svg-tit">修改</span>
            </span>
          </el-tooltip>
          <el-tooltip
            content="刪除組別"
            placement="top"
          >
            <span
              title="刪除組別"
              style="margin: 0 27px"
              class="del-org"
              @click="handleDel(selectedDepartment)"
            >
              <icon-svg
                :name="selectedDepartment.departmentID === parentId ? 'shanchu11' : 'shanchu1-copy'"
                class="del-org-icon"
              />
              <span :class="['svg-tit', { 'svg-titColor': selectedDepartment.departmentID === parentId }]">刪除</span>
            </span>
          </el-tooltip>
          <el-tooltip
            content="停用或啟用組別"
            placement="top"
          >
            <span @click="handleUpdate(selectedDepartment)">
              <icon-svg
                :name="selectedDepartment.departmentID === parentId ? 'tingyongzhanghu1' : 'tingyongzhanghu1-copy'"
                class="disable-org-icon"
              />
              <span :class="['svg-tit', { 'svg-titColor': selectedDepartment.departmentID === parentId }]">啟用/停用</span>
            </span>
          </el-tooltip>
        </div>
        <!-- 组织表格 -->
        <div class="table-contain org-table">
          <el-table
            v-loading="departmentLoading"
            :data="departmentTableData"
            style="width: 100%"
            empty-text="暫無數據"
          >
            <el-table-column
              prop="departmentName"
              label="組別名稱"
            />
            <el-table-column
              prop="departmentManagerName"
              label="組別負責人"
            >
              <template slot-scope="scope">
                {{ scope.row.departmentManagerName ? scope.row.departmentManagerName : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              prop="rcreateTime"
              label="創建時間"
            >
              <template slot-scope="scope">
                {{ scope.row.createTime | getTime }}
              </template>
            </el-table-column>
            <el-table-column label="狀態">
              <template slot-scope="scope">
                {{ scope.row.status | statusTransition }}
              </template>
            </el-table-column>
            <!-- <el-table-column label="操作" v-if="permissions.System_Org_Manager">
              <template slot-scope="{row}">
                <el-button type="text" @click="handleEdit(row)">編輯</el-button>
                <el-button
                  type="text"
                  @click="handleUpdate(row)"
                  v-if="row.departmentID === parentId?false:true"
                >{{row.status ==='Normal'?'停用':'啟用'}}</el-button>
                <el-button
                  type="text"
                  @click="handleDel(row)"
                  v-if="row.departmentID === parentId?false:true"
                >刪除</el-button>
              </template>
            </el-table-column>-->
          </el-table>
        </div>
        <div class="title">
          員工列表
        </div>
        <!-- 员工表格 -->
        <div class="table-contain">
          <el-table
            v-loading="staffLoading"
            :data="staffTableData"
            style="width: 100%"
            empty-text="暫無數據"
          >
            <el-table-column
              prop="name"
              label="員工姓名"
              :width="13 * 12 + 'px'"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ scope.row.name ? scope.row.name : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              prop="telephone"
              label="電話"
              :width="13 * 9 + 'px'"
              show-overflow-tooltip
            >
              <template slot-scope="{ row }">
                {{ row.telephone | phoneFormat }}
              </template>
            </el-table-column>
            <el-table-column
              prop="WhatsApp"
              label="WhatsApp"
              :width="13 * 9 + 'px'"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span v-if="scope.row.isShowWhatsApp">
                  {{ scope.row.telephone ? scope.row.telephone.substring(0, 4) + '&nbsp;' + scope.row.telephone.substring(4, 8) : '-' }}
                </span>
                <span v-else>
                  {{ scope.row.whatsApp ? scope.row.whatsApp.substring(0, 4) + '&nbsp;' + scope.row.whatsApp.substring(4, 8) : '-' }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="email"
              label="電郵"
              :width="13 * 16 + 'px'"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ scope.row.email ? scope.row.email : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              prop="departmentName"
              label="組別"
              show-overflow-tooltip
            />
            <el-table-column
              label="角色"
              :width="13 * 8 + 'px'"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ roleTransition[scope.row.roleID] }}
              </template>
            </el-table-column>
            <el-table-column
              prop="status"
              label="狀態"
              :width="13 * 4 + 'px'"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ scope.row.status | statusTransition }}
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination clearfix">
            <div
              v-if="false"
              class="count"
            >
              <span>當前查詢記錄：{{ staffTotal }}</span>
              <span>總記錄：{{ staffTotalCount }}</span>
            </div>
            <el-pagination
              background
              :page-size="staffPageCount"
              :page-sizes="[10, 20, 50, 100]"
              :current-page.sync="staffPageIndex"
              layout="total,sizes,prev, pager,next, jumper"
              :total="staffTotal"
              @size-change="handleStaffSizeChange"
              @current-change="handleStaffCurrentChange"
            />
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import asideBar from './components/asideBar';
import iconSvg from './components/icon-svg';
import { mapState } from 'vuex';
export default {
    name: 'OrgManage',
    components: {
        asideBar,
        iconSvg
    },
    data() {
        return {
            isExpanded: false,
            parentId: 0, //当前用户组织id
            departmentId: '', //左侧选中的组织id
            treeLoading: false,
            treeData: [], //树形数据
            departmentTableData: [],
            departmentLoading: false,
            selectedDepartment: {},

            staffPageCount: 10,
            staffPageIndex: 1,
            staffTotal: 0,
            staffTotalCount: 0,
            staffLoading: false,
            staffTableData: [],
            roleOptions: [],
            //
            containerHeight: 0,
            standardHeight: 0,
            // currentPermissions: [
            //   { name: "System_Org_Examine", show: true },
            //   { name: "System_Org_Manager", show: true }
            // ]
            // driver: null,
            steps: [
                {
                    element: '.create-org',
                    popover: {
                        className: !this.$route.params.initiativeGuide ? 'first-guidance' : 'one h160',
                        title: '新增組別，<br /> 建立賬戶專屬的業務架構',
                        doneBtnText: '下一步',
                        closeBtnText: '關閉'
                    },
                    onNext: () => {
                        this.$router.push({
                            name: this.pub.routeNameLists.StaffingIndex,
                            params: {
                                guide: 1,
                                initiativeGuide: this.$route.params.initiativeGuide
                            }
                        });
                    }
                }
            ]
        };
    },
    created() {
        this.parentId = this.userInfo.departmentID;
        this.departmentId = this.parentId;
        this.staffPageCount = this.pub.getPageSize(this.$store.state.userInfo.accountID, 'orgmanPageCount') || 10;
        // console.log(this.parentId);
        this.getDepartmentsTree();
        this.getDepartmentById(this.parentId);
        this.searchCompanyUserInfo();
        this.serachRoleInfo();
    },
    mounted() {
        // 計算頁面的基本高度
        this.standardHeight = window.innerHeight - document.getElementById('header').offsetHeight - 120;
        // 新手导航
        if (this.$route.params.guide) {
            setTimeout(() => {
                this.pub.guide(this.Driver, this.steps);
            }, 500);
        }
    },
    methods: {
        choseOrganization(data) {
            this.departmentId = data.departmentID;
            this.selectedDepartment = data;
            this.getDepartmentById(this.departmentId);
            this.searchCompanyUserInfo();
        },
        // 获取组织树结构
        async getDepartmentsTree() {
            this.treeLoading = true;
            let res = await this.axios.get(this.pub.getApi().GetDepartmentsTreeByParentID, {
                params: {
                    departmentID: this.parentId
                }
            });
            // console.log(res);
            let { code, message, result } = res.data;
            this.treeLoading = false;
            if (code === 0) {
                this.treeData = [result];
                this.departmentName = result.departmentName;
                this.remainderPropertyCoin = result.remainderPropertyCoin;
            }
        },
        // 通過id獲取組別信息
        async getDepartmentById(departmentID) {
            let res = await this.axios.get(this.pub.getApi().GetDepartmentById, {
                params: {
                    departmentID
                }
            });
            let { code, result, message } = res.data;
            // console.log(res);
            if (code === 0) {
                this.departmentTableData = [result];
                this.selectedDepartment = result;
                // console.log(this.selectedDepartment);
            }
        },
        handleEdit({ departmentID }) {
            this.$router.push({
                path: `/org-manage/edit/${departmentID}`
            });
        },
        handleUpdate({ departmentID, status, departmentName }) {
            if (departmentID === this.parentId) {
                return;
            }
            let contentText = '',
                paramsStatus = '';
            if (status === 'Normal') {
                contentText = `您確認停用${departmentName}, 是否繼續?`;
                paramsStatus = 'disable';
            } else {
                contentText = `您確認啟用${departmentName}, 是否繼續?`;
                paramsStatus = 'normal';
            }
            this.$confirm(contentText, '提示', {
                confirmButtonText: '確認',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(async () => {
                    let res = await this.axios.post(this.pub.getApi().UpdateDepartmentStatusByID, {
                        departmentID,
                        status: paramsStatus
                    });
                    // console.log("update", res);
                    let { result, code, message } = res.data;
                    if (code === 0) {
                        this.$message({
                            type: 'success',
                            message: '設置成功!',
                            showClose: true
                        });
                        this.getDepartmentById(this.departmentId);
                    } else {
                        this.$message({
                            type: 'error',
                            message: '設置失敗!',
                            showClose: true
                        });
                    }
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消設置',
                        showClose: true
                    });
                });
        },
        handleDel({ departmentID, departmentName }) {
            if (departmentID === this.parentId) {
                return;
            }
            this.$confirm(`您確認刪除${departmentName}, 是否繼續?`, '提示', {
                confirmButtonText: '確認',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.removeDepartment(departmentID);
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消刪除',
                        showClose: true
                    });
                });
        },
        async removeDepartment(departmentID) {
            let res = await this.axios.get(this.pub.getApi().RemoveDepartment, {
                params: {
                    departmentID
                }
            });
            // console.log("del", res);
            let { result, code, message } = res.data;
            if (code === 0) {
                this.$message({
                    type: 'success',
                    message: '刪除成功!',
                    showClose: true
                });
                this.departmentId = this.parentId;
                this.getDepartmentsTree();
                this.getDepartmentById(this.departmentId);
                this.searchCompanyUserInfo();
            } else if (code === 2026 || code === 2027 || code === 2028 || code === 2029) {
                this.$message({
                    type: 'error',
                    message: '刪除失敗，請先將組別下的資源進行轉移',
                    showClose: true
                });
            } else {
                this.$message({
                    type: 'error',
                    message,
                    showClose: true
                });
            }
        },
        // 获取员工列表
        async searchCompanyUserInfo(data = {}) {
            // console.log("departmet", this.departmentId);
            this.staffLoading = true;
            let res = await this.axios.post(
                this.pub.getApi().SearchCompanyUserInfo,
                Object.assign(
                    {
                        departmentID: this.departmentId,
                        pageIndex: this.staffPageIndex,
                        pageCount: this.staffPageCount
                    },
                    data
                )
            );
            // console.log("userInfo", res);
            this.staffLoading = false;
            let { code, message, result } = res.data;
            if (code === 0) {
                this.staffTableData = result.data;
                this.staffTotal = result.count;
                if (Object.keys(data).length === 0) {
                    this.staffTotalCount = result.count;
                }
            }
        },
        //获取角色信息
        async serachRoleInfo() {
            let res = await this.axios.post(this.pub.getApi().SerachRoleInfo, {
                pageIndex: 1,
                pageCount: 99
            });
            // console.log('roleInfo', res)
            let { result, code, message } = res.data;
            if (code === 0) {
                this.roleOptions = result.data;
                // console.log(result.data)
            }
        },
        handleStaffSizeChange(val) {
            this.pub.userPageSize(this.$store.state.userInfo.accountID,'orgmanPageCount',val) 
            this.staffPageCount = val;
            this.staffPageIndex = 1;
            this.searchCompanyUserInfo();
        },
        handleStaffCurrentChange(val) {
            this.staffPageIndex = val;
            this.searchCompanyUserInfo();
        }
    },
    computed: {
        ...mapState([
            // 映射 this.count 为 store.state.count
            'userInfo',
            'permissions'
        ]),
        roleTransition() {
            let data = {};
            this.roleOptions.forEach(item => {
                data[item.roleID] = item.roleName;
            });
            return data;
        },
        asideHeight() {
            if (this.containerHeight > this.standardHeight) {
                return this.containerHeight;
            } 
                return this.standardHeight;
            
        }
    },
    filters: {
        // 状态过滤器
        statusTransition(val) {
            switch (val) {
                case 'Normal':
                    return '啟用';
                    break;
                case 'Disable':
                    return '停用';
                    break;
                default:
                    false;
            }
        },
        phoneFormat(val) {
            if (val && val.length === 8) {
                return val.substr(0, 4) + ' ' + val.substr(4);
            } else if (val && val.length === 13) {
                return val.substr(0, 3) + ' ' + val.substr(3, 4) + ' ' + val.substr(7);
            } else if (!val) {
                return '-';
            } 
                return val;
            
        }
    },
    watch: {
        staffTableData: {
            deep: true,
            handler() {
                this.containerHeight = 0;
                this.$nextTick(() => {
                    this.containerHeight = document.getElementById('org-main').offsetHeight;
                    // console.log("dom", document.getElementById("org-main"));
                    // console.log("height", this.containerHeight);
                });
            }
        }
    }
};
</script>
<style lang="less" scpoed>
@import '../../assets/css/element-reset.less';
.org-manage {
    text-align: left;
    // padding-left: 20px;
    padding-bottom: 20px;

    // .el-container {
    // }
    .org-manage-header {
        // padding: 18px 0 24px;
        padding-bottom: 24px;
        font-size: 24px;
        color: #171725;
    }
    .el-aside {
        border-radius: 10px;
        min-width:340px;
        transition: width 0.3s ease;
        overflow-x: hidden;
    }
    .el-main {
        padding: 0 0px 0px 20px;
        .operate-btn {
            margin-bottom: 20px;
            display: flex;
            align-items: center;
            span {
                font-size: 20px;
            }
            .add-org-icon {
                width: 20px;
                height: 20px;
            }
            .vertical-line {
                width: 2px;
                display: inline-block;
                height: 22px;
                background-color: #e3e3ea;
                margin: 0 30px;
            }
            .edit-org-icon {
                height: 20px;
                width: 20px;
            }
            .del-org-icon {
                height: 20px;
                // width: 16px;
            }
            .disable-org-icon {
                height: 20px;
                width: 20px;
            }
            .el-button {
                // width: 145px;
                height: 38px;
                border-radius: 10px;
            }
        }
        .table-contain {
            border-radius: 10px;
            padding: 15px 10px;
            background-color: #fff;
            .pagination {
                // text-align: center;
                margin-top: 20px;
                line-height: 35px;
                .count {
                    float: left;
                    span ~ span {
                        margin-left: 10px;
                    }
                }
                .el-pagination {
                    float: right;
                }
            }
            &.org-table {
                .el-table {
                    /deep/.el-table__row > td {
                        border: none;
                    }
                    &::before {
                        height: 0;
                    }
                }
            }
        }
        .title {
            height: 30px;
            line-height: 30px;
            margin-top: 15px;
            font-size: 16px;
        }
    }
    .clearfix:after {
        content: '';
        display: block;
        height: 0;
        clear: both;
        visibility: hidden;
    }
    .clearfix {
        /* 触发 hasLayout */
        zoom: 1;
    }
}
.svg-tit {
    font-size: 15px !important;
    padding-left: 5px;
    color: #0062ff;
    cursor: pointer;
}
.svg-titColor {
    color: #666 !important;
}
</style>
